/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 09 Jan 2025
 * Time: 10:17 AM
 * Email: mdmehedihasanroni28@gmail.com
 */

import * as URL from "../helpers/Constants";
import axios from "axios";

export default class BkashPaymentService {

    static createBkashPayment(id, data) {
        return axios.post(`${URL.CREATE_BKASH_PAYMENT_URL}/${id}`, data, {
                ...BkashPaymentService.getAuthHeader(),
            }
        );
    }

    static createFullDiscountComplete(pharmacyId, data) {
        return axios.post(`${URL.CREATE_FULL_DISCOUNT_COMPLETE_URL}/${pharmacyId}`, data, {
                ...BkashPaymentService.getAuthHeader(),
                params: data
            }
        );
    }

    static getAllBkashPaymentTransaction(id) {
        return axios.get(`${URL.GET_ALL_BKASH_PAYMENT_TRANSACTION_URL}/${id}`, {
                ...BkashPaymentService.getAuthHeader(),
            }
        );
    }

    static getAllBkashTransactions(page, size, pharmacyName, transactionNumber, from, to) {
        return axios.get(URL.GET_BKASH_TRANSACTION_URL, {
            ...BkashPaymentService.getAuthHeader(),
            params: {page, size, pharmacyName, transactionNumber, from, to}
        });
    }

    static getBkashTransactionById(transactionId) {
        return axios.get(URL.GET_BKASH_TRANSACTION_BY_ID_URL.replace("{transactionId}", transactionId), {
            ...BkashPaymentService.getAuthHeader()
        });
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }
}